import { render } from "./AppWrapper.vue?vue&type=template&id=a5cd0aca&ts=true"
import script from "./AppWrapper.vue?vue&type=script&lang=ts"
export * from "./AppWrapper.vue?vue&type=script&lang=ts"

import "./AppWrapper.vue?vue&type=style&index=0&id=a5cd0aca&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__